import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'shared/contexts/AuthContext.tsx';
import { useDebouncedCallback } from 'use-debounce';
import { RealtimerProviderContext } from '../../realtimer/RealtimerProviderContext.ts';

export const useRealtimer = (audience: string, callback: (message: any) => any) => {
  const { subscribe, unsubscribe, isConnected } = useContext(RealtimerProviderContext);
  const { isAuthenticated } = useContext(AuthContext);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const callCallback = useDebouncedCallback(callback, 100);

  useEffect(() => {
    if (isConnected && isSubscribed) {
      return;
    }

    if (isConnected && !isSubscribed && isAuthenticated) {
      subscribe(audience, callCallback);
      setIsSubscribed(true);
    }
  }, [isConnected, isSubscribed, subscribe, setIsSubscribed]);

  useEffect(() => {
    if (!isSubscribed) {
      return;
    }

    if (isSubscribed && (!isConnected || !isAuthenticated)) {
      unsubscribe(audience, callback);
      setIsSubscribed(false);
    }
  }, [isSubscribed, isConnected, setIsSubscribed, unsubscribe]);

  useEffect(() => {
    return () => {
      unsubscribe(audience, callback);
      setIsSubscribed(false);
    };
  }, [unsubscribe, setIsSubscribed]);
};
